import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import DateSelection from './pages/DateSelection';
import TicketSelection from './pages/TicketSelection';
import Billing from './pages/Billing';
import BookingConfirmation from './pages/BookingConfirmation';
import PaymentSuccess from './pages/PaymentSuccess';
import Ticket from './pages/Ticket';
import { BookingProvider } from './context/BookingContext';
import Footer from './components/Footer';

function App() {
  return (
    <BookingProvider>
      <Router>
        <>
          <Routes>
            <Route path="/" element={<DateSelection />} />
            <Route path="/tickets" element={<TicketSelection />} />
            <Route path="/billing" element={<Billing />} />
            <Route path="/confirmation" element={<BookingConfirmation />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/ticket" element={<Ticket />} />
          </Routes>
          <Footer />
        </>
      </Router>
    </BookingProvider>
  );
}

export default App;
